/**
 * HER LEWK — collection-page loadout JS.
 *
 * IIFE, no globals. Per-section instance via dataset.lfLewkInitialized.
 *
 * Behavior:
 *   - Add To Lewk button toggles .added on gear-card, updates bundle bar
 *   - Size selector (variant-select): user picks variant; selection is
 *     locked once the card is added (dashed magenta) until un-added
 *   - Secret slot click → unlock animation + reveal product
 *   - Bundle bar tracks added items, surfaces 15% / 20% messaging
 *   - Equip CTA flow (cart drawer compatible):
 *       1. Apply discount silently via hidden iframe (sets session cookie)
 *       2. POST /cart/add.js with all added variants
 *       3. Dispatch standard cart-update events (cart:refresh, cart:updated,
 *          theme:cart:reload, monster-cart:open) so the active cart drawer
 *          opens with the items + discount applied
 *   - CRT idle scan sweep every 3.0s on the spotlight frame
 */
(function () {
  'use strict';

  // Backup cart-drawer events for any other listeners on the page.
  // Monster Cart Upsell & Free Gifts is handled via direct global calls
  // (window.openCart / window.monster_refresh) — see openMonsterCart() below.
  var CART_OPEN_EVENTS = [
    'cart:refresh',
    'cart:updated',
    'theme:cart:reload'
  ];

  function init(root) {
    if (!root) return;
    if (root.dataset.lfLewkInitialized === '1') return;
    root.dataset.lfLewkInitialized = '1';

    var spotlightFrame  = root.querySelector('.spotlight-frame');
    var secretSlot      = root.querySelector('.secret-slot');
    var bundleBar       = root.querySelector('.bundle-bar');
    var bundleFill      = root.querySelector('.bundle-fill');
    var bundleCount     = root.querySelector('.bundle-count-text');
    var bundleDiscount  = root.querySelector('.bundle-discount');
    var bundleCta       = root.querySelector('.bundle-cta');
    var bundleCtaText   = bundleCta ? bundleCta.querySelector('.bundle-cta-text') : null;
    var bundleSegments  = root.querySelector('.bundle-segments');
    var pieceCount      = root.querySelector('.piece-count');

    var state = {
      added: new Map(), // variantId -> { handle, price, slot }
      secretUnlocked: false,
      totalSlots: 4,
    };

    if (secretSlot && secretSlot.classList.contains('unlocked')) {
      state.secretUnlocked = true;
      state.totalSlots = 5;
    }

    // ── Wire variant-select dropdowns (size selectors) ─────────────
    var variantSelects = root.querySelectorAll('.variant-select');
    variantSelects.forEach(function (sel) {
      sel.addEventListener('change', function () {
        var card = sel.closest('.gear-card, .secret-slot');
        if (!card) return;
        // Sync the card's data-variant-id with the current selection
        card.dataset.variantId = sel.value;
      });
      // Initialize: ensure card's dataset matches the current select value
      var card = sel.closest('.gear-card, .secret-slot');
      if (card) card.dataset.variantId = sel.value;
    });

    // ── Wire Add To Lewk buttons ────────────────────────────────────
    var addButtons = root.querySelectorAll('.add-to-lewk');
    addButtons.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        toggleAdd(btn);
      });
    });

    // ── Secret slot unlock on click (outside button) ────────────────
    if (secretSlot) {
      secretSlot.addEventListener('click', function (e) {
        if (state.secretUnlocked) return;
        if (e.target.closest('.add-to-lewk')) return;
        unlockSecret();
      });
    }

    // ── Bundle CTA (cart drawer flow) ───────────────────────────────
    if (bundleCta) {
      bundleCta.addEventListener('click', function () { checkout(); });
    }

    function toggleAdd(btn) {
      var card = btn.closest('.gear-card, .secret-slot');
      if (!card) return;
      // Always re-read variant-id from card.dataset (updated by select change)
      var variantId = card.dataset.variantId;
      if (!variantId) return;
      var handle = card.dataset.handle || '';
      var price  = parseFloat(card.dataset.price || '0');
      var slot   = card.dataset.slot || 'secret';

      var btnText = btn.querySelector('.btn-text');

      if (card.classList.contains('added')) {
        // Remove — clear ALL prior variants for this card (in case size was changed)
        card.classList.remove('added');
        state.added.delete(variantId);
        if (btnText) btnText.textContent = '+ Add To Lewk';
      } else {
        card.classList.add('added');
        card.classList.remove('scanning');
        void card.offsetWidth;
        card.classList.add('scanning');
        setTimeout(function () { card.classList.remove('scanning'); }, 800);
        state.added.set(variantId, { handle: handle, price: price, slot: slot });
        if (btnText) btnText.textContent = '✓ Added · Tap to Remove';
      }

      updateBundleBar();
    }

    function unlockSecret() {
      if (!secretSlot || state.secretUnlocked) return;
      secretSlot.classList.add('revealing');
      setTimeout(function () {
        secretSlot.classList.add('unlocked');
        secretSlot.classList.remove('revealing');
        state.secretUnlocked = true;
        state.totalSlots = 5;
        if (pieceCount) pieceCount.textContent = '05';
        if (bundleSegments) {
          var newSeg = document.createElement('div');
          newSeg.className = 'bundle-seg';
          bundleSegments.appendChild(newSeg);
        }
        if (bundleBar) bundleBar.classList.add('unlocked');
        updateBundleBar();
      }, 500);
    }

    function updateBundleBar() {
      var count = state.added.size;
      var total = state.totalSlots;
      var pct = total > 0 ? (count / total) * 100 : 0;

      if (bundleFill)  bundleFill.style.width = pct + '%';
      if (bundleCount) bundleCount.textContent = count + '/' + total + ' PIECES';

      if (!bundleDiscount || !bundleCtaText || !bundleBar) return;

      if (state.secretUnlocked) {
        if (count >= 5) {
          bundleDiscount.textContent = '★ FULL SET — 20% OFF ACTIVE';
          bundleBar.classList.add('full');
          bundleCtaText.textContent = 'Checkout The Full Lewk';
        } else {
          bundleDiscount.textContent = '★ ' + (5 - count) + ' MORE FOR 20% OFF';
          bundleBar.classList.remove('full');
          bundleCtaText.textContent = 'Equip The Full Lewk';
        }
      } else {
        if (count >= 4) {
          bundleDiscount.textContent = '✓ 15% OFF ACTIVE — UNLOCK SECRET FOR 20%';
          bundleBar.classList.add('full');
          bundleCtaText.textContent = 'Checkout The Full Lewk';
        } else {
          bundleDiscount.textContent = (4 - count) + ' MORE FOR 15% OFF';
          bundleBar.classList.remove('full');
          bundleCtaText.textContent = 'Equip The Full Lewk';
        }
      }
    }

    // ── Cart-drawer compatible checkout flow ────────────────────────
    function applyDiscountSilent(code) {
      // Load /discount/CODE in a hidden iframe so the session cookie
      // is set without navigating away. The ?redirect=/cart.js gives
      // the iframe a small JSON page to load (fast, no theme assets).
      return new Promise(function (resolve) {
        var iframe = document.createElement('iframe');
        iframe.setAttribute('aria-hidden', 'true');
        iframe.setAttribute('tabindex', '-1');
        iframe.style.cssText =
          'position:absolute;left:-9999px;top:-9999px;width:1px;height:1px;border:0;visibility:hidden;';
        var done = false;
        function finish() {
          if (done) return;
          done = true;
          try { iframe.remove(); } catch (e) {}
          resolve();
        }
        iframe.addEventListener('load', finish);
        iframe.src = '/discount/' + encodeURIComponent(code) + '?redirect=/cart.js';
        document.body.appendChild(iframe);
        // Safety: don't block forever if the iframe never fires load
        setTimeout(finish, 2500);
      });
    }

    function triggerCartDrawer() {
      // === Monster Cart Upsell & Free Gifts (Monster Apps) ===
      // The app exposes these globals from its cart_renderer.js:
      //   window.monster_refresh()  — re-pull cart and re-render drawer
      //   window.openCart()         — open the drawer
      //   window.closeCart()        — close it
      //   window.monster_atc({id, quantity})  — single-item add (auto-opens)
      // We use refresh + openCart since we did the cart-add in bulk via /cart/add.js
      try {
        if (typeof window.monster_refresh === 'function') window.monster_refresh();
      } catch (e) { console.error('[lewk-loadout] monster_refresh failed:', e); }
      try {
        if (typeof window.openCart === 'function') window.openCart();
      } catch (e) { console.error('[lewk-loadout] openCart failed:', e); }

      // Generic events as backup for any other listeners on the page
      CART_OPEN_EVENTS.forEach(function (name) {
        try {
          document.dispatchEvent(new CustomEvent(name, { bubbles: true, detail: { source: 'lewk-loadout' } }));
        } catch (e) {}
      });
    }

    function checkout() {
      var items = [];
      state.added.forEach(function (_v, vid) {
        var id = parseInt(vid, 10);
        if (!isNaN(id)) items.push({ id: id, quantity: 1 });
      });

      if (items.length === 0) {
        triggerCartDrawer();
        return;
      }

      var count = state.added.size;
      var code = null;
      if (state.secretUnlocked && count >= 5)      code = 'LEWK20';
      else if (count >= 4)                         code = 'LEWK15';

      if (bundleCta) bundleCta.disabled = true;
      if (bundleCtaText) bundleCtaText.textContent = 'Adding…';

      var work = code ? applyDiscountSilent(code) : Promise.resolve();
      work
        .then(function () {
          return fetch('/cart/add.js', {
            method:  'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body:    JSON.stringify({ items: items })
          });
        })
        .then(function (r) {
          if (!r.ok) throw new Error('cart add HTTP ' + r.status);
          return r.json();
        })
        .then(function () {
          // Items are in cart + discount cookie set. Open the drawer.
          triggerCartDrawer();
          updateBundleBar();
        })
        .catch(function (err) {
          console.error('[lewk-loadout] cart flow failed:', err);
          // Fallback: full-page redirect to /cart with discount applied
          window.location.href = code ? '/discount/' + code + '?redirect=/cart' : '/cart';
        })
        .then(function () {
          // Always re-enable the button (success or fail)
          setTimeout(function () {
            if (bundleCta) bundleCta.disabled = false;
          }, 800);
        });
    }

    // ── CRT idle scan loop ──────────────────────────────────────────
    if (spotlightFrame) {
      var IDLE_MS = 3000;
      var idleInterval;

      function triggerIdleScan() {
        spotlightFrame.classList.remove('scanning', 'flashing');
        void spotlightFrame.offsetWidth;
        spotlightFrame.classList.add('scanning');
        setTimeout(function () { spotlightFrame.classList.remove('scanning'); }, 1100);
      }

      setTimeout(function () {
        spotlightFrame.classList.add('flashing');
        setTimeout(function () { spotlightFrame.classList.remove('flashing'); }, 1100);
        idleInterval = setInterval(triggerIdleScan, IDLE_MS);
      }, 600);
    }

    updateBundleBar();
  }

  function initAll() {
    document.querySelectorAll('.lewk-loadout').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target) {
      var root = e.target.querySelector('.lewk-loadout');
      if (root) init(root);
    }
  });
})();
